import { render } from "./Variable-popup.vue?vue&type=template&id=52b35b1b&scoped=true"
import script from "./Variable-popup.vue?vue&type=script&lang=js"
export * from "./Variable-popup.vue?vue&type=script&lang=js"

import "./variablePopupStyle.scss?vue&type=style&index=0&id=52b35b1b&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b35b1b"]])

export default __exports__